import React from 'react'
import DefaultPolicy from 'components/pages/users/defaultPolicy/DefaultPolicy'
import { DefaultPolicyPageLoader } from 'v2/modules/usersManagement'
import { isMyFeatureOn } from 'lib/splitio'
import { FEATURES } from 'lib/splitioFeatures'

const DefaultPolicySelector = () => {
  const isRolledOut = isMyFeatureOn(FEATURES.EGD_React_QNS_Admin_Quarantine_Notification_Rollout)

  switch (true) {
    case isRolledOut: {
      return <DefaultPolicyPageLoader />
    }
    default: {
      return <DefaultPolicy />
    }
  }
}

export default DefaultPolicySelector
